import { Component } from '@verndale/core';
import { createFocusTrap } from 'focus-trap';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import keys from '../utils/keys';

class QuTodayHeader extends Component {
  setupDefaults() {
    this.dom = {
      $mobileMenuTrigger: this.el._$('.qu-today-header__mobile-menu-trigger'),
      $desktopMenuTrigger: this.el._$('.qu-today-header__desktop-menu-trigger'),
      $nav: this.el._$('.qu-today-header__nav'),
      $closeMenu: this.el._$('.qu-today-header__close-menu'),
      $mobileSearchForm: this.el._$('.qu-today-header__mobile-search-form'),
      $mobileSearchTrigger: this.el._$(
        '.qu-today-header__mobile-search-trigger'
      ),
      $mobileForm: this.el._$('.qu-today-header__top-right-search'),
      $forms: this.el._$$('form'),
      $clearInputs: this.el._$$('.qu-today-header__clear-input')
    };

    const self = this;
    this.navTrap = createFocusTrap(this.dom.$nav, {
      escapeDeactivates: false,
      clickOutsideDeactivates: true,
      onActivate() {
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'hidden';
        document.body.style.width = '100%';
        disableBodyScroll(self.dom.$nav, {
          allowTouchMove: (el) =>
            el.closest('.qu-today-header__nav-content-main')
        });
      },
      onDeactivate() {
        document.body.removeAttribute('style');
        clearAllBodyScrollLocks();
      }
    });
    this.searchTrap = createFocusTrap(this.dom.$mobileForm, {
      escapeDeactivates: false
    });
    this.setViewportHeight();
  }

  addListeners() {
    this.dom.$mobileSearchTrigger._on(
      'click',
      ::this.handleMobileSearchTrigger
    );
    this.dom.$mobileMenuTrigger._on('click', ::this.handleOpenMenu);
    this.dom.$desktopMenuTrigger._on('click', ::this.handleOpenMenu);
    this.dom.$closeMenu._on('click', ::this.handleCloseMenu);
    this.dom.$nav._on('click', ::this.handleNavClick);
    this.dom.$nav._on('keydown', ::this.handleCloseMenuEsc);
    this.dom.$mobileForm._on('keydown', ::this.handleCloseMobileEsc);
    this.dom.$forms._on('input', ::this.handleFormState);
    this.dom.$clearInputs._on('click', ::this.handleClearInputs);
  }

  handleClearInputs(e) {
    const form = e.currentTarget.closest('form');
    const input = form._$('input');
    if (form && input) {
      form.reset();
      form.dataset.hasValue = false;
      input.focus();
    }
  }

  handleFormState(e) {
    e.currentTarget.dataset.hasValue = e.target.value.length > 0;
  }

  handleNavClick(e) {
    if (e.target === this.dom.$nav) {
      this.handleCloseMenu();
    }
  }

  handleCloseMobileEsc(e) {
    if (e.keyCode === keys.escape) {
      this.closeMobileSearch();
    }
  }

  handleCloseMenuEsc(e) {
    if (e.keyCode === keys.escape) {
      this.handleCloseMenu();
    }
  }

  handleCloseMenu() {
    this.dom.$mobileMenuTrigger.ariaExpanded = false;
    this.dom.$desktopMenuTrigger.ariaExpanded = false;
    this.dom.$nav.hidden = true;
    setTimeout(() => this.navTrap.deactivate(), 360);
  }

  handleOpenMenu() {
    this.dom.$mobileMenuTrigger.ariaExpanded = true;
    this.dom.$desktopMenuTrigger.ariaExpanded = true;
    this.dom.$nav.hidden = false;
    this.dom.$mobileSearchTrigger.ariaExpanded = false;
    this.dom.$mobileSearchForm.hidden = true;
    setTimeout(() => this.navTrap.activate(), 360);
  }

  handleMobileSearchTrigger() {
    if (this.dom.$mobileSearchTrigger.ariaExpanded === 'true') {
      this.closeMobileSearch();
    } else {
      this.openMobileSearch();
    }
  }

  closeMobileSearch() {
    this.dom.$mobileSearchTrigger.ariaExpanded = false;
    this.searchTrap.deactivate();
    this.dom.$mobileSearchForm.hidden = true;
  }

  openMobileSearch() {
    this.dom.$mobileSearchTrigger.ariaExpanded = true;
    this.searchTrap.activate();
    this.dom.$mobileSearchForm.hidden = false;
  }

  setViewportHeight() {
    function handleResize() {
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight}px`
      );
    }

    handleResize();
    window.addEventListener('resize', handleResize);
  }
}

export default QuTodayHeader;
